import { render, staticRenderFns } from "./config-workflow.vue?vue&type=template&id=26496e3e&scoped=true"
import script from "./config-workflow.vue?vue&type=script&lang=js"
export * from "./config-workflow.vue?vue&type=script&lang=js"
import style0 from "./config-workflow.vue?vue&type=style&index=0&id=26496e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26496e3e",
  null
  
)

export default component.exports